<template>
	<aside class="app-sidebar col-md-3">
		<nav class="app-nav">
			<ul class="nav">
				<li><router-link to="home">What We Do</router-link></li>
				<li><router-link to="website-development">Website Development</router-link></li>
				<li><router-link to="front-end-outsourcing">Front End Outsourcing</router-link></li>
				<!--<li><router-link to="services">Services</router-link></li>-->
				<li><router-link to="technologies">Technologies We Use</router-link></li>
				<li><router-link to="team">Who We Are</router-link></li>
				<!--<li><router-link to="projects">Projects</router-link></li>-->
				<li><router-link to="contactus">Contact Us</router-link></li>
			</ul>
		</nav>
		<router-link v-if="$route && $route.name && $route.name !== 'contactus'" to="contactus" class="btn btn-success btn-block btn-lg text-uppercase hireus">
			Hire Us <span class="glyphicon glyphicon-chevron-right"></span>
		</router-link>
		<div class="tag-cloud" v-if="$route && $route.name !== 'home'">
			<h4>Popular Tags:</h4>
			<router-link v-for="tag in tags" :to="tag.link" class="btn btn-default btn-xs">{{tag.name}}</router-link>
		</div>
	</aside>
</template>

<script>
	export default {
		name: 'appSidebar',
		props: [],
		data () {
			return {
			    tags: [
					{ name: 'Development', link: 'home' },
					{ name: 'Front-End', link: 'home' },
					{ name: 'Mobile App', link: 'home' },
					{ name: 'CMS', link: 'website-development' },
					{ name: 'Angular 2.0', link: 'technologies' },
					{ name: 'Vue.js', link: 'technologies' },
					{ name: 'Webpack', link: 'technologies' },
					{ name: 'Node.js', link: 'technologies' },
					{ name: 'React', link: 'technologies' },
					{ name: 'Git', link: 'technologies' },
					{ name: 'Polymer', link: 'technologies' },
					{ name: 'HTML5', link: 'technologies' },
					{ name: 'Website', link: 'website-development' },
					{ name: 'Outsourcing', link: 'front-end-outsourcing' }
				]
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.app-sidebar .app-nav { margin-bottom:20px; background-color:#e5e5e5; }
	.app-sidebar .app-nav .nav li a { display:block; padding-left:10px; border-left:5px solid #ccc; }
	.app-sidebar .app-nav .nav li a:hover,
	.app-sidebar .app-nav .nav li a.active { background: #d5d5d5; }
	.app-sidebar .app-nav .nav li a:hover { border-left:5px solid #5cb85c; }
	.app-sidebar .app-nav .nav li a.active { border-left:5px solid #2e83cb; }
	.app-sidebar .hireus { margin-bottom:20px; }
	.app-sidebar .tag-cloud { filter:opacity(0.7); transition: 0.7s; }
	.app-sidebar .tag-cloud:hover { filter:opacity(1); }
	.app-sidebar .tag-cloud .btn { margin:0 5px 5px 0; }
</style>



// WEBPACK FOOTER //
// appSidebar.vue?495a82bc